module.exports = __webpack_public_path__ + "static/img/credigo.1fae29f1.svg";